export default __webpack_public_path__ + "static/media/and-local.6bcce7d7.svg";